module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "title"
    }
  }, [_c('p', {
    staticClass: "bk"
  }, [_vm._v("Seven for"), _c('br'), _vm._v("a Secret")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bksub",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("A John, the Lord Chamberlain Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Mary Reed & Eric Mayer")]), _vm._v(" "), _c('p', {
    staticClass: "bkau1"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "http://www.home.earthlink.net/~maywrite/",
      "target": "_blank"
    }
  }, [_vm._v("www.home.earthlink.net/~maywrite/")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("Poisoned Pen Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/ppp-logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491e8249","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-sevensecret002.vue
// module id = 60
// module chunks = 0